(function () {
  var SUPPORTED = ['FR', 'BE'];
  var DEFAULT_REGION = 'FR';
  var REGION_OPTION_NAME = 'Region';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var REGION = window.KS_REGION || DEFAULT_REGION;
  if (SUPPORTED.indexOf(REGION) === -1) REGION = DEFAULT_REGION;

  function ssGet(key) {
    try { return sessionStorage.getItem(key); } catch (e) { return null; }
  }

  function ssSet(key, val) {
    try { sessionStorage.setItem(key, val); } catch (e) { /* noop */ }
  }

  function url(path) {
    return ROOT.replace(/\/$/, '') + path;
  }

  function optionNames(product) {
    var names = product.options || [];
    return names.map(function (entry) {
      return typeof entry === 'string' ? entry : (entry && entry.name) || '';
    });
  }

  function regionIndexFromCartItem(item) {
    var opts = item.options_with_values || [];
    for (var i = 0; i < opts.length; i++) {
      if (opts[i] && opts[i].name === REGION_OPTION_NAME) return i;
    }
    return -1;
  }

  function findTargetVariant(product, item, cartRegionIndex) {
    var names = optionNames(product);
    var regionIndex = names.indexOf(REGION_OPTION_NAME);
    if (regionIndex === -1) regionIndex = cartRegionIndex;
    if (regionIndex === -1) return null;

    var current = (item.options_with_values || []).map(function (o) {
      return o ? o.value : null;
    });

    var variants = product.variants || [];
    for (var i = 0; i < variants.length; i++) {
      var variant = variants[i];
      var values = variant.options || [];
      if (values.length !== current.length) continue;

      var match = true;
      for (var j = 0; j < values.length; j++) {
        var expected = j === regionIndex ? REGION : current[j];
        if (values[j] !== expected) {
          match = false;
          break;
        }
      }

      if (match) return variant;
    }

    return null;
  }

  function addVariant(variantId, quantity, properties) {
    return fetch(url('/cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: quantity,
          properties: properties || {}
        }]
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    });
  }

  function removeLine(key) {
    return fetch(url('/cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function (r) {
      if (!r.ok) throw new Error('remove failed');
      return r.json();
    });
  }

  function swapItem(item) {
    var cartRegionIndex = regionIndexFromCartItem(item);
    if (cartRegionIndex === -1) return Promise.resolve(false);

    var opts = item.options_with_values || [];
    var currentRegion = opts[cartRegionIndex] ? opts[cartRegionIndex].value : null;
    if (!currentRegion || currentRegion === REGION) return Promise.resolve(false);
    if (SUPPORTED.indexOf(currentRegion) === -1) return Promise.resolve(false);

    return fetch(url('/products/' + item.handle + '.js'))
      .then(function (r) {
        if (!r.ok) throw new Error('product fetch failed');
        return r.json();
      })
      .then(function (product) {
        var target = findTargetVariant(product, item, cartRegionIndex);
        if (!target) return false;
        if (target.id === item.variant_id) return false;
        if (target.available === false) return false;

        return addVariant(target.id, item.quantity, item.properties)
          .then(function () {
            return removeLine(item.key);
          })
          .then(function () {
            return true;
          });
      })
      .catch(function () {
        return false;
      });
  }

  function syncCartRegion() {
    return fetch(url('/cart.js'))
      .then(function (r) {
        if (!r.ok) throw new Error('cart fetch failed');
        return r.json();
      })
      .then(function (cart) {
        var items = cart.items || [];
        var chain = Promise.resolve(false);
        var changed = false;

        items.forEach(function (item) {
          chain = chain.then(function () {
            return swapItem(item).then(function (didSwap) {
              if (didSwap) changed = true;
            });
          });
        });

        return chain.then(function () {
          if (changed) {
            document.dispatchEvent(new CustomEvent('ks:region-cart-synced', {
              detail: { region: REGION }
            }));
          }
          return changed;
        });
      })
      .catch(function (e) {
        console.warn('Region cart sync skipped', e);
        return false;
      });
  }

  if (ssGet('ks_geo_done')) { syncCartRegion(); return; }

  if (/[?&]country=/.test(location.search)) {
    ssSet('ks_geo_done', '1');
    syncCartRegion();
    return;
  }

  if (/bot|crawl|spider|lighthouse/i.test(navigator.userAgent)) {
    syncCartRegion();
    return;
  }

  fetch(url('/browsing_context_suggestions.json'))
    .then(function (r) {
      if (!r.ok) throw new Error('suggestions fetch failed');
      return r.json();
    })
    .then(function (data) {
      ssSet('ks_geo_done', '1');

      var detected =
        data && data.detected_values && data.detected_values.country &&
        data.detected_values.country.handle;

      if (detected) detected = String(detected).toUpperCase();

      if (detected && detected !== REGION && SUPPORTED.indexOf(detected) !== -1) {
        var next = new URL(location.href);
        next.searchParams.set('country', detected);
        location.replace(next.toString());
        return;
      }

      syncCartRegion();
    })
    .catch(function () {
      syncCartRegion();
    });
})();